<template>
  <div class="element-input element-textbox element-terms" :class="{ disabled }">
    <div>
      <ul>
        <li :class="{ on: item.value }" @click="clickTerms(index)" v-for="(item,index) in value">{{ item.label }}<p @click="statusPopup = true">상세</p></li>
      </ul>
      <div class="error" v-if="error">{{ error }}</div>
    </div>

    <element-term-popup v-model="statusPopup" @input="clickPopup" />

  </div>
</template>
<script>
export default {
  props: [ "value", "label", "category", "error", "disabled", "placeholder" ],
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  data(){
    return {
      statusPopup : false,
    }
  },
  methods: {
    selectItem( value ){
      this.$emit( "input", value );
    },
    clickTerms( index ) {
      this.value[index].value = !this.value[index].value;
    },
    clickPopup() {
      this.statusPopup = false;
    }
  }

}
</script>
